import CustomInputNumber from './inputNumber';

export default CustomInputNumber;
